import type { EstadoProyecto } from "../api/types";

// Etiquetas humanas en espanol para cada estado de la maquina
// (backend/app/models.py: draft | generando | listo | fallido |
// cuota_agotada | budget_exceeded -- este ultimo M6, ver generation_worker.py).
export const ETIQUETAS_ESTADO: Record<EstadoProyecto, string> = {
  draft: "Borrador",
  generando: "Generando",
  listo: "Listo",
  fallido: "Con error",
  cuota_agotada: "Cuota agotada",
  budget_exceeded: "Presupuesto agotado",
};

// Familia de color para el badge por estado.
export const CATEGORIA_ESTADO: Record<
  EstadoProyecto,
  "neutral" | "progreso" | "exito" | "error"
> = {
  draft: "neutral",
  generando: "progreso",
  listo: "exito",
  fallido: "error",
  cuota_agotada: "error",
  budget_exceeded: "error",
};

export function esTerminal(estado: EstadoProyecto): boolean {
  return (
    estado === "listo" ||
    estado === "fallido" ||
    estado === "cuota_agotada" ||
    estado === "budget_exceeded"
  );
}
